module.exports = __webpack_public_path__ + "static/media/map.4f18804d.svg";